import React from "react";
import RiskSentinel from "../RiskSentinel";

export default function SentinelTab({ openProof }) {
  return (
    <div className="space-y-5" data-testid="tab-sentinel-content">
      <RiskSentinel onOpenRiskProof={(s) => openProof("RISK", s)} />
    </div>
  );
}
